var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "no-stacking": "",
      "size": "lg"
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon_logo_violet.svg"),
      "alt": ""
    }
  })]), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('b-row', {
    staticClass: "mt-4 pr-4"
  }, [_c('b-col', {
    attrs: {
      "offset": "2"
    }
  }, [_c('h2', {
    staticClass: "heading tw-mb-2"
  }, [_vm._v(" Are you sure you want to clear " + _vm._s(_vm.patientName) + " from your queue? "), _vm.tab === 'doctorrequest' ? [_vm._v(" This will mark this doctor request as complete. ")] : _vm._e()], 2)])], 1), _c('b-row', {
    staticClass: "mt-4 pr-4"
  }, [_c('b-col', {
    attrs: {
      "offset": "2"
    }
  }, [_c('div', {
    staticClass: "tw-grid tw-grid-cols-2 tw-gap-2"
  }, [_c('div', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Patient")]), _c('p', [_vm._v(_vm._s(_vm.patientName))])]), _c('div', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Birthday")]), _c('p', [_vm._v(_vm._s(_vm.rowData.birthday))])]), _c('div', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Doctor")]), _c('p', [_vm._v(" " + _vm._s(_vm.rowData.doctorid === 'NONE' ? 'No doctor assigned' : `Dr. ${_vm.rowData.doctorname}`) + " ")])]), _c('div', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Date Onboarded")]), _c('p', [_vm._v(" " + _vm._s(_vm.rowData.dateonboarded ? _vm.getDate(_vm.rowData.dateonboarded) : 'Not yet onboarded') + " ")])]), _c('div', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Email")]), _c('p', {
    staticClass: "tw-text-nowrap tw-text-ellipsis tw-overflow-hidden",
    attrs: {
      "title": _vm.rowData.email
    }
  }, [_vm._v(" " + _vm._s(_vm.rowData.email) + " ")])]), _c('div', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Contact No.")]), _c('p', [_vm._v(_vm._s(_vm.rowData.phoneno))])])])])], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "offset": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_vm._v(" Back ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(" Confirm ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };